export const CELL_CONTAINER_SELECTOR = '.temp-account-cell-container';

export const DAYS_LEFT_HEADER_SELECTOR = '.temp-account-days-left';

export const CELL_CLASS_LIST = ['temp-account-cell', 'cgp-theme-property-border-color-base03', 'cgp-theme-property-background-color-base03'];

export const CELL_CONTENT_CLASS = ['temp-account-cell-content', 'cy-temp-account-days-number','cgp-theme-property-color-main'];

export const CELL_CONTENT_BAR_CLASS = ['temp-account-content-bar', 'cgp-theme-property-border-bottom-color-darkmain'];